/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS43MTQxOCAxNC44NTk0TDMuNDI4NDcgMTQuODU5NEwzLjQyODQ3IDEuMTQ1MDlMNS43MTQxOCAxLjE0NTA5TDUuNzE0MTggMTQuODU5NFoiIGZpbGw9ImJsYWNrIi8+PHBhdGggZD0iTTEyLjU3MTQgMTQuODU5NEwxMC4yODU2IDE0Ljg1OTRMMTAuMjg1NiAxLjE0NTA5TDEyLjU3MTQgMS4xNDUwOUwxMi41NzE0IDE0Ljg1OTRaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==";